export const routePath = {
  home: '/',
  auth: '/auth',
  team: '/team',
  resetPassword: '/reset-password',
  settings: '/settings',
  videoDetails: '/video-details',
  components: '/components',
};

export const routeName = {
  home: 'Home',
  auth: 'Auth',
  team: 'Team',
  resetPassword: 'ResetPassword',
  settings: 'Settings',
  videoDetails: 'VideoDetails',
  components: 'Components',
};
